import { configureStore, ThunkAction, Action } from '@reduxjs/toolkit';
import { authReducer } from '../reducers/AuthReducer';
import { sharingReducer } from '../reducers/SharingReducer';
import  pageAdminReducer  from '../pages/Admin/AdminPageActions';
import  pageHomeReducer  from '../pages/Home/HomePageActions';
import  pageDashboardReducer  from '../pages/Dashboard/DashboardPageActions';




export const store = configureStore({
  middleware: (getDefaultMiddleware) => getDefaultMiddleware({
    immutableCheck: { ignoredPaths: ['some.nested.path'] },
    serializableCheck: { ignoredPaths: ['some.nested.path'] }
  }),
  reducer: {
    login: authReducer,
    sharingReducer: sharingReducer,
    adminPageReducer: pageAdminReducer,
    homePageReducer: pageHomeReducer,
    dashboardPageReducer: pageDashboardReducer,

  },
});
{/* @ts-ignore*/}
export type AppDispatch = typeof store.dispatch;
export type RootState = ReturnType<typeof store.getState>;
export type AppThunk<ReturnType = void> = ThunkAction<
  ReturnType,
  RootState,
  unknown,
  Action<string>
>;
